<template>
    <ul class="errors" v-if="currentError">
        <li>
            {{ currentError.message }}
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        errors: {
            type: Object,
            default() {
                return {};
            },
        },
        field: {
            type: String,
            default: "",
        },
    },
    computed: {
        currentError() {
            return this.errors[this.field];
        },
    },
};
</script>
